<script setup>

import { computed, inject, ref } from "vue";
import { useCommunityCompaniesStore } from "@/stores/communityCompaniesStore";
import edaTools from "@/lib/es-bill-shared-js/misc/edaTools";
import ExportOdoo from "@/lib/es-bill-shared-js/exports/odoo/ExportOdoo";
import { saveAs } from 'file-saver';
import { PrimaryButton } from '@es-bill/es-bill-common-components';

const communityCompaniesStore = useCommunityCompaniesStore();
const localeToUse = ref("de-AT")

const communityCompaniesNotDemoNorEP = computed(() => {
  return communityCompaniesStore.allCommunityCompanies.filter(c =>
    edaTools.isEcnValidExternal(c.ecn) && !c.ecn.startsWith("EP")
  )
})

const communitiesReport = computed(() => {
  let cr = [];

  for(const c of  communityCompaniesNotDemoNorEP.value) {
    // $log.warn(c);

    cr.push({
      ...c,
      exportMembers: c,
    });
  }

  cr.sort((a, b) => a.dateFirstActive - b.dateFirstActive);

  return cr;
});

const tableHeader = computed(() => {
  let cols = [];

  cols = cols.concat([
    { title: "Name EG", key: 'name' },
    // { title: "ECN",  key: 'ecn' },
    // { title: "Rechtsform", key: 'legal' },
    { title: "Identifikation", key: 'billingData.identification' },

    { title: "USt.-Satz [%]", key: 'billingData.taxInfo.taxRatePercentPoints' },
    { title: "Hinweis", key: 'billingData.taxInfo.taxNote' },
    { title: "UID", key: 'billingData.taxInfo.uid' },

    { title: "IBAN", key: 'billingData.wireInfo.iban' },
    { title: "BIC", key: 'billingData.wireInfo.bic' },
    // { title: "Creditor-ID", key: 'billingData.wireInfo.creditorId' },

    { title: "Mitglieder", key: 'exportMembers' },


  ]);

  return cols;
});

function exportOdooMemberDataToClient(communityCompany) {

  const eo = new ExportOdoo(console);
  const xlsData = eo.generateOdooExportMembers(communityCompany);
  if(xlsData)
    saveAs(xlsData,"VertigisFM-EM_Export.xlxs"); // only fallback name
}

</script>


<script>
export default {
  name: 'ViewExportOdoo',
}
</script>


<template>
  <v-container class="containerBase pa-0">

    <v-container class="containerStandard">

      <p class="textHeadline">{{ $t('export-odoo') }}</p>
      Angepasste Exporte für Odoo.<br><br>

      <v-data-table :headers="tableHeader"
                    :items="communitiesReport"
                    :hide-default-footer="true"
                    :page="1"
                    :items-per-page="1000"
      >
        <template v-slot:[`item.exportMembers`]="{ value }">
          <PrimaryButton @click="exportOdooMemberDataToClient(value)" :text="$t ? $t('export') : 'Export'" />
        </template>

      </v-data-table>


    </v-container>
  </v-container>
</template>

<style>


</style>
